import "./bootstrap";
import "../css/app.css";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";

const appName = import.meta.env.VITE_APP_NAME || "Anniversary Contest";

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: (name) => {
        const pages = import.meta.glob([
            "../../app-modules/**/resources/js/Pages/**/*.vue",
            "./Pages/**/*.vue",
        ]);

        const findPageBySuffix = (suffix) => {
            const normalizedSuffix = suffix.replace(/\\+/g, "/");
            return Object.keys(pages).find((path) =>
                path.replace(/\\+/g, "/").endsWith(normalizedSuffix)
            );
        };

        let pageComponent = null;

        const parts = name.split("/");
        if (parts.length >= 2) {
            const moduleNameFromRender = parts[0];
            const pagePathInModule = parts.slice(1).join("/");

            let moduleFolderPath = moduleNameFromRender
                .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
                .toLowerCase();

            let modulePath = `../../app-modules/${moduleFolderPath}/resources/js/Pages/${pagePathInModule}.vue`;
            if (pages[modulePath]) {
                pageComponent = pages[modulePath];
            } else {
                const resolvedModulePath = findPageBySuffix(
                    `/app-modules/${moduleFolderPath}/resources/js/Pages/${pagePathInModule}.vue`
                );
                if (resolvedModulePath) {
                    pageComponent = pages[resolvedModulePath];
                }
            }
        }

        if (!pageComponent) {
            let mainAppPath = `./Pages/${name}.vue`;
            if (pages[mainAppPath]) {
                pageComponent = pages[mainAppPath];
            } else {
                const resolvedMainPath = findPageBySuffix(`/resources/js/Pages/${name}.vue`);
                if (resolvedMainPath) {
                    pageComponent = pages[resolvedMainPath];
                }
            }
        }

        if (pageComponent) {
            return pageComponent();
        } else {
            console.error(`Inertia Page Not Found: "${name}".`);
            return Promise.reject(
                new Error(`Inertia Page Not Found: "${name}".`)
            );
        }
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(App, props),
        });

        app.use(plugin).use(ZiggyVue);

        return app.mount(el);
    },
    progress: {
        color: "#4B5563",
    },
});
